<template>
<v-dialog
    v-model="dialog"
    fullscreen
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>Billing Batch Operation Status</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
               
                <v-btn
                    dark
                    text
                    @click="onClickSave"
                >
                    Close
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-card-text
            style="padding-top: 15px"
        >


            <v-data-table
                v-if="results != null"
                :headers="headers"
                :items="results"
                :items-per-page="100"
                class="elevation-1"
                :hide-default-footer="true"
                disable-sort
                :footer-props="{
                    disableItemsPerPage: false,
                    disablePagination: false,
                }"
            >
            
                <template v-slot:item.state="{ item }">
                    <v-chip
                        :color="getStateColor(item.state)"
                    >
                        {{item.state}}
                    </v-chip>
                </template>
            
            </v-data-table>

        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            last_dialog_guard: null,
            batch_id: null,

            results: [],

            headers: [
                { text: 'Organization', value: 'for_organization_label'},
                { text: 'Operation', value: 'type'},
                { text: 'State', value: 'state'},
                { text: 'Message', value: 'error_message'},
            ],
        }
    },

    methods: {

        showDialog(batch_id)
        {
            this.batch_id = batch_id;
            this.dialog = true;
            this.last_dialog_guard = this.$router.dialog_guard;
            this.$router.dialog_guard = this.dialogGuard;
            this.update();
        },

        update()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/billing/red-chirp-monthly-invoices/batch-operations',
            
                'params' : {
                        'batch_id': this.batch_id,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;

                        let has_pending = false;

                        for ( let i = 0; i < data.results.length; i++ )
                        {
                            if ( data.results[i].state == 'pending' ) 
                            {
                                has_pending = true;
                                break;
                            }
                        }

                        if ( has_pending )
                        {
                            window.setTimeout(() => { this.update(); }, 1000);
                        }  
                    },
            
                'on_error': 'Unable to complete API call',
            });
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = this.last_dialog_guard;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.closeDialog();
                return;
            }
        
            this.closeDialog();
            next(false);
        },

        onClickSave()
        {
            this.closeDialog();
            this.$emit("close");
        },

        onClickCancel()
        {
            this.closeDialog();
        },

        getStateColor(state)
        {
            if ( state == 'pending' ) return null;
            if ( state == 'success' ) return 'green lighten-4';
            if ( state == 'failed' ) return 'red lighten-4';

            return null;
        },

    },
}
</script>

<style lang="scss" scoped>
</style>